export const getters = {
  getModalViewPurchase: state => state.modalViewPurchase,
  getPurchases: state => state.purchases,
  getPurchase: state => state.purchase
};

export default {};
